// Static blog posts data. Editable directly here.
export const BLOG_POSTS = [
  {
    slug: "guia-completa-itin-2026",
    title: "Guía completa: ¿Cómo obtener tu ITIN en 2026?",
    excerpt:
      "Todo lo que necesitas saber para tramitar tu Individual Taxpayer Identification Number (ITIN): requisitos, documentos, tiempos y errores comunes.",
    category: "ITIN",
    date: "15 de enero, 2026",
    readTime: "6 min",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85",
    content: [
      {
        h: "¿Qué es el ITIN y para qué sirve?",
        p: "El ITIN (Individual Taxpayer Identification Number) es un número de identificación fiscal emitido por el IRS para personas que necesitan cumplir con obligaciones tributarias en Estados Unidos pero no son elegibles para obtener un Social Security Number. Es indispensable si trabajas, tienes ingresos en EE.UU., abres una cuenta bancaria o quieres declarar impuestos.",
      },
      {
        h: "¿Quién necesita un ITIN?",
        p: "Extranjeros residentes y no residentes que reciben ingresos en EE.UU., dependientes o cónyuges de residentes/ciudadanos que aparecen en declaraciones de impuestos, estudiantes extranjeros con becas, y personas que reciben ingresos por trabajo independiente o inversiones en el país.",
      },
      {
        h: "Documentos que necesitas",
        p: "Pasaporte vigente (o combinación de documentos de identidad y prueba de estatus migratorio), formulario W-7 completado, declaración de impuestos federal (formulario 1040), y prueba del propósito por el cual necesitas el ITIN.",
      },
      {
        h: "¿Cuánto tarda el proceso?",
        p: "El IRS demora entre 7 y 11 semanas en procesar solicitudes de ITIN, aunque puede tardar más durante temporada alta (enero a abril). Con Great Solutions US te acompañamos durante todo el proceso para evitar errores que pueden retrasar tu trámite.",
      },
      {
        h: "Errores comunes que debes evitar",
        p: "Enviar documentos sin certificar, no incluir la declaración de impuestos junto con el W-7, información incompleta en el formulario, o firmar en el lugar equivocado. Cualquiera de estos errores puede hacer que el IRS rechace tu solicitud.",
      },
    ],
  },
  {
    slug: "llc-o-corporation-que-elegir",
    title: "LLC o Corporation: ¿Cuál es mejor para tu pequeño negocio?",
    excerpt:
      "Entiende las diferencias clave entre una LLC y una Corporation para tomar la decisión correcta al abrir tu negocio en Florida.",
    category: "Negocios",
    date: "10 de enero, 2026",
    readTime: "5 min",
    image:
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85",
    content: [
      {
        h: "¿Qué es una LLC?",
        p: "Una Limited Liability Company (LLC) es la estructura más popular entre pequeños negocios en Florida. Protege tus bienes personales de las deudas del negocio, ofrece flexibilidad fiscal (puedes elegir cómo tributar) y tiene menos requisitos administrativos que una Corporation.",
      },
      {
        h: "¿Qué es una Corporation?",
        p: "Una Corporation (S-Corp o C-Corp) es una entidad separada de sus dueños. Ofrece protección legal robusta y permite emitir acciones para atraer inversionistas. Sin embargo, requiere más formalidades: junta directiva, actas, reuniones anuales, etc.",
      },
      {
        h: "Diferencias fiscales importantes",
        p: "La LLC por defecto tributa como 'pass-through' (los impuestos pasan al dueño). La C-Corp paga impuestos como entidad y los dueños pagan de nuevo por dividendos (doble tributación). Una S-Corp evita esto pero tiene restricciones de propietarios.",
      },
      {
        h: "¿Cuál elegir para tu caso?",
        p: "Si eres un emprendedor con 1-3 socios buscando simplicidad y protección: LLC. Si planeas atraer inversores externos, tener empleados con acciones o vender el negocio: Corporation. En Great Solutions US analizamos tu caso específico para recomendarte lo mejor.",
      },
    ],
  },
  {
    slug: "deducciones-impuestos-2026",
    title: "10 deducciones de impuestos que muchos hispanos no aprovechan",
    excerpt:
      "Deducciones legítimas del IRS que pueden reducir tu factura fiscal significativamente. La mayoría no las conocen.",
    category: "Impuestos",
    date: "5 de enero, 2026",
    readTime: "7 min",
    image:
      "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=1200&q=80&auto=format&fit=crop",
    content: [
      {
        h: "1. Crédito Tributario por Hijos (CTC)",
        p: "Si tienes hijos menores de 17 años que son ciudadanos o residentes, puedes calificar para hasta $2,000 por hijo. Con ITIN también puedes calificar para el Credit for Other Dependents (hasta $500).",
      },
      {
        h: "2. Crédito por Ingreso del Trabajo (EITC)",
        p: "Para familias trabajadoras de ingresos bajos y medios. Puede llegar hasta $7,830 si tienes 3 o más hijos calificados. Requiere Social Security.",
      },
      {
        h: "3. Gastos de educación",
        p: "American Opportunity Credit hasta $2,500 por estudiante universitario. Lifetime Learning Credit hasta $2,000 por familia para cursos de mejora profesional.",
      },
      {
        h: "4. Gastos médicos",
        p: "Si gastos médicos superan el 7.5% de tu ingreso ajustado (AGI), puedes deducir el excedente. Incluye seguros, medicinas recetadas, terapias, viajes médicos.",
      },
      {
        h: "5. Contribuciones a IRA tradicional",
        p: "Hasta $7,000 al año ($8,000 si tienes 50+) pueden ser deducibles y reducir tu ingreso gravable. Además ahorras para el retiro.",
      },
      {
        h: "6. Gastos de home office",
        p: "Si trabajas desde casa como independiente, puedes deducir una porción de renta, servicios, internet y equipo. Debe ser un espacio exclusivo para trabajar.",
      },
      {
        h: "7. Millas de negocio",
        p: "Si usas tu vehículo para trabajo (no commute regular), puedes deducir 67 centavos por milla en 2026. Lleva un registro detallado.",
      },
      {
        h: "8. Donaciones caritables",
        p: "Donaciones en efectivo o bienes a organizaciones registradas (501c3) son deducibles si detallas. Guarda todos los recibos.",
      },
      {
        h: "9. Intereses de préstamos estudiantiles",
        p: "Hasta $2,500 de intereses pagados en préstamos estudiantiles pueden reducir tu ingreso gravable.",
      },
      {
        h: "10. Gastos de trabajo independiente",
        p: "Si eres self-employed: seguros médicos, equipos, software, marketing, transporte, capacitación, servicios profesionales. Reduce dramáticamente tu factura fiscal.",
      },
    ],
  },
  {
    slug: "notarizacion-en-florida-guia",
    title: "Notarización en Florida: cuándo la necesitas y cómo prepararte",
    excerpt:
      "Guía práctica para que tu documento notarizado sea válido a la primera y no tengas que repetir el trámite.",
    category: "Notaría",
    date: "28 de diciembre, 2025",
    readTime: "4 min",
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85",
    content: [
      {
        h: "¿Qué es una notarización?",
        p: "Es un acto oficial por el cual un Notary Public certifica que la firma en un documento es auténtica y que el firmante lo hizo voluntariamente y con capacidad legal. Da validez legal al documento.",
      },
      {
        h: "Documentos que suelen requerir notarización",
        p: "Poderes notariales (Power of Attorney), declaraciones juradas (Affidavits), autorizaciones de viaje para menores, cartas de consentimiento, autenticación de firmas para trámites en el extranjero, contratos privados, declaraciones de residencia.",
      },
      {
        h: "Qué debes traer",
        p: "Identificación oficial vigente con foto (Driver's License, pasaporte, cédula de otro país aceptada), el documento sin firmar (¡no firmes antes!), información de testigos si aplica.",
      },
      {
        h: "Errores comunes",
        p: "Firmar el documento antes de llegar a la notaría (invalida el trámite), llevar ID vencida, no leer el documento antes de firmar, esperar hasta el último momento.",
      },
      {
        h: "Nuestro servicio",
        p: "Como Notary Public certificada del estado de Florida, atendemos con cita previa o walk-in. Ofrecemos notarizaciones express, apostilla (con proveedor certificado) y guía sobre qué necesitas exactamente.",
      },
    ],
  },
];

export const CATEGORIES = ["Todos", "ITIN", "Impuestos", "Negocios", "Notaría"];
